import { checkScriptIsLoaded } from './script-utils.esm.js';

var MAPBOX_SCRIPT_ID = 'mapbox';
var loadScript = function (head, url, scriptId, resolveImmediately) {
    return new Promise(function (resolve) {
        var prev = document.getElementById(scriptId);
        if (prev) {
            prev.remove();
        }
        var script = document.createElement('script');
        script.setAttribute('id', scriptId);
        script.src = url;
        script.async = true;
        script.defer = true;
        if (!resolveImmediately) {
            script.onload = function () {
                resolve();
            };
        }
        head === null || head === void 0 ? void 0 : head.appendChild(script);
        if (resolveImmediately) {
            resolve();
        }
    });
};
var checkApiIsLoaded = function () { return window.mapboxgl; };
var checkApiIsLoading = function () { return window.mapboxglLoading; };
/**
 * Load mapbox api.
 *
 * @param reloadSDK force to reload sdk if already loaded. Useful when you want to change the locale that has been loaded.
 * @param conf the api configuration to used
 * @param resolveImmediately don't way for mapbox callback to revolve this call.
 * @returns returns true if the api was loaded through this call, and false if the api was already loaded and not force to be reloaded.
 */
var initMapBoxApi = function (reloadSDK, conf, resolveImmediately) {
    return new Promise(function (resolve) {
        if (checkApiIsLoaded() && !reloadSDK) {
            resolve(false);
        }
        else if (checkApiIsLoading()) {
            checkScriptIsLoaded('mapboxgl', checkApiIsLoaded, checkApiIsLoading, { delay: 200, maxRetries: 100 }).then(function () {
                return resolve(false);
            });
        }
        else {
            window.mapboxglLoading = true;
            window.mapboxgl = undefined;
            var jsUrl = conf.jsUrl, _a = conf.pluginsUrl, pluginsUrl = _a === void 0 ? [] : _a, cssUrl_1 = conf.cssUrl;
            var head_1 = document.querySelector('head') ||
                (function () {
                    var h = document.createElement('head');
                    return document.appendChild(h);
                })();
            // Scripts
            var promises_1 = [];
            if (jsUrl) {
                promises_1.push(loadScript(head_1, jsUrl, MAPBOX_SCRIPT_ID, resolveImmediately));
            }
            pluginsUrl.forEach(function (pluginUrl, index) {
                promises_1.push(loadScript(head_1, pluginUrl, "".concat(MAPBOX_SCRIPT_ID, "-plugins-").concat(index), resolveImmediately));
            });
            Promise.all(promises_1)
                .then(function () {
                // Style
                if (cssUrl_1) {
                    var styleId = "".concat(MAPBOX_SCRIPT_ID, "-style");
                    var prev = document.getElementById(styleId);
                    if (prev) {
                        prev.remove();
                    }
                    var link = document.createElement('link');
                    link.setAttribute('id', styleId);
                    link.rel = 'stylesheet';
                    link.href = cssUrl_1;
                    head_1.appendChild(link);
                }
            })
                .then(function () {
                window.mapboxglLoading = undefined;
                resolve(true);
            });
        }
    });
};

export { initMapBoxApi };
